<form class="tab-form"  [formGroup]="settlorType == 1 ? individualForm : institutionForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate >
  <!-- Panel 1: Institution Info -->
  <ng-template #institutionInfo let-i="index">
    <div *ngIf="settlorType == 0 && getSettlorFormGroup(i)">
      <div class="line-section"></div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" controlName="InstitutionName"
          label="Name of Institution" hint="Enter name"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" controlName="BusinessNature"
          label="Nature of Business" hint="Select nature of business"
          inputType="select"
          [ArrayItems]="BusinessNatureOptions"
          [loadingOptions]="loadingBizNature"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
      </div>
      
      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="Phone" label="Organisation Phone Number"  inputType="phone"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="Email" label="Organisation Email Address" hint={{emailLabel}}
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
      </div>

      <div class="row half">
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="Address" label="Organisation Physical Address" hint={{addressHint}}
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
      </div>
    </div>
  </ng-template>
  <!-- Panel 2: Authorisers -->
  <ng-template #authoriserInfo let-i="index">
    <div *ngIf="getSettlorFormGroup(i)">
      <div class="line-section"></div>

      <div formArrayName="Authorisers" *ngIf="getAuthorisers()">
          <div *ngFor="let contact of getAuthorisers().controls; let j=index" [formGroupName]="j" style="position: relative;">
            <div *ngIf="getAuthorisersFormGroup(j)">
              <div style="height: 50px;" *ngIf="j > 1"></div>
              <div class="line-2" *ngIf="j > 0"></div>

              <p class="blue lead" *ngIf="j > 0">
                {{'Authoriser ' + (j+1)}}
              </p>

              <div class="row-alt">
                <div class="row-mini">
                  <app-input [formGroup]="getAuthorisersFormGroup(j)" controlName="Title"
                    label={{titleLabel}} hint={{titleHint}}
                    inputType="auto-complete"
                    [loadingOptions]="loadingTitles"
                    [ArrayItems]="TitleOptions"
                    required="false"
                    [validationMessages]="validationMessages" [formErrors]="formErrors">
                  </app-input>

                  <app-input [formGroup]="getAuthorisersFormGroup(j)" controlName="FirstName"
                    label={{fNameLabel}} hint={{fNameHint}}
                    [validationMessages]="validationMessages" [formErrors]="formErrors">
                  </app-input>
                </div>
                <div class="row-mini">
                  <app-input [formGroup]="getAuthorisersFormGroup(j)" controlName="MiddleName"
                    label={{mNameLabel}} hint={{mNameHint}} required='false'
                    [validationMessages]="validationMessages" [formErrors]="formErrors" >
                  </app-input>
                  <app-input [formGroup]="getAuthorisersFormGroup(j)" controlName="LastName"
                    label={{surnameLabel}} hint={{surnameHint}}
                    [validationMessages]="validationMessages" [formErrors]="formErrors" >
                  </app-input>
                </div>
              </div>
                
              <div class="row">
                <app-input [formGroup]="getAuthorisersFormGroup(j)" controlName="Phone"
                  class="grid-item" label={{phoneLabel}}  inputType="phone"
                  [validationMessages]="validationMessages" [formErrors]="formErrors">
                </app-input>
                <app-input [formGroup]="getAuthorisersFormGroup(j)" controlName="Email"
                  class="grid-item" label={{emailLabel}} hint={{emailLabel}}
                  [validationMessages]="validationMessages" [formErrors]="formErrors">
                </app-input>
              </div>

              <div class="remove-button" *ngIf="j > 0">
                <button mat-stroked-button type="button" (click)="removeAuthoriser(j)">
                  <div style="display: flex; flex: 1; align-items: center;">
                    <span class="button-text">
                      <u>{{ 'Remove Authoriser' }}</u>
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
      </div>

      <!-- BUTTTON Add Authoriser-->
      <div class="blueStroke row" [ngClass]="{'min-55' : getAuthorisers() && getAuthorisers().length > 1}">
        <button mat-stroked-button  type="button"
          [disabled]="!(institutionForm.valid && settlors[i]?.Authorisers[settlors[i]?.Authorisers?.length-1]?.verified)"
          (click)="addNewAuthoriser()">
            <span class="button-text">
                {{ '+ Add Authoriser' }}
            </span>
        </button>
      </div>
    </div>
  </ng-template>
  <!-- Panel 3: Upload Documents -->
  <ng-template #uploadDocs let-i="index">
    <div *ngIf="getSettlorFormGroup(i)">
      <div class="line-section"></div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="IDNoImage"
          [label]="'Upload Registration Certificate' "
          [fileFunction]="updateIDObject.bind(this, i)"
          [existingFileName]="settlors[i]?.IDNoImage?.name != '' ? settlors[i]?.IDNoImage?.name : '' "
          inputType="file"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="KraPinImage"
          [label]="'Upload Organisation KRA PIN' "
          [fileFunction]="updateKraObject.bind(this, i)"
          [existingFileName]="settlors[i]?.KraPinImage?.name != '' ? settlors[i]?.KraPinImage?.name : '' "
          inputType="file"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
      </div>
    </div>
  </ng-template>
  <!-- Panel 4: Principal -->
  <ng-template #princInfo let-i="index">
    <section formGroupName="Principal" *ngIf="getPrincipalFormGroup(0)">
      <div class="line-section"></div>
      <p class="principal-context">
        To be filled <b>ONLY</b> if the Trust is being set up to hold Death Benefits.
      </p>
      <div class="line-2"></div>

      <div class="blueStroke row" *ngIf="!addDesceased">
        <button mat-stroked-button class="general-stroked-button" type="button" (click)="ondesceasedChange(true)">
          <span class="button-text">
            + Add Deceased
          </span>
        </button>
      </div>

      <div *ngIf="addDesceased">
        <p class="principal-context">
          Enter the deceased person's details below:
        </p>

        <div class="row-mini">
          <app-input [formGroup]="getPrincipalFormGroup(i)" controlName="FirstName"
            label={{fNameLabel}} hint={{fNameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
          <app-input [formGroup]="getPrincipalFormGroup(i)" controlName="MiddleName"
            label={{mNameLabel}} hint={{mNameHint}} required='false'
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
          <app-input [formGroup]="getPrincipalFormGroup(i)" controlName="LastName"
            label={{surnameLabel}} hint={{surnameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
        </div>

        <div class="row half">
          <app-input [formGroup]="getPrincipalFormGroup(i)" class="grid-item"
            controlName="DeathCertImage"
            label="Upload Death Certificate"
            [fileFunction]="updateDeathObject.bind(this)"
            inputType="file"
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
        </div>

        <div class="line-2"></div>

        <div class="remove-button" style="padding-top: 0px;">
          <button mat-stroked-button type="button" (click)="ondesceasedChange(false)">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>Remove</u>
              </span>
            </div>
          </button>
        </div>
      </div>
    </section>
  </ng-template>

  <!-- Individuals -->
  <!-- Panel 1: Individual Info -->
  <ng-template #settlorInfo let-i="index">
    <div *ngIf="getSettlorFormGroup(i)">
      <div class="line-section"></div>

      <div class="row-alt">
        <div class="row-mini">
          <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Title"
            label={{titleLabel}} hint={{titleHint}}
            inputType="auto-complete"
            [loadingOptions]="loadingTitles"
            [ArrayItems]="TitleOptions"
            required="false"
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>

          <app-input [formGroup]="getSettlorFormGroup(i)" controlName="FirstName"
            label={{fNameLabel}} hint={{fNameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
        </div>
          
        <div class="row-mini">
          <app-input [formGroup]="getSettlorFormGroup(i)" controlName="MiddleName"
            label={{mNameLabel}} hint={{mNameHint}} required='false'
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
          <app-input [formGroup]="getSettlorFormGroup(i)" controlName="LastName"
            label={{surnameLabel}} hint={{surnameHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors" >
          </app-input>
        </div>
      </div>
      
      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)"  controlName="Phone"
          class="grid-item" label={{phoneLabel}}  inputType="phone"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Email"
          class="grid-item" label={{emailLabel}} hint={{emailLabel}}
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
      </div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Nationality"
          label={{nationalityLabel}} hint={{nationalityHint}}
          inputType="auto-complete"
          [ArrayItems]="CountryOptions"
          [loadingOptions]="loadingCountries"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>

        <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Gender"
          label={{genderLabel}} hint={{genderHint}}
          inputType="select"
          [ArrayItems]="GenderOptions"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
      </div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" controlName="Country"
          label={{countryLabel}} hint={{countryHint}}
          inputType="auto-complete"
          [ArrayItems]="CountryOptions"
          [loadingOptions]="loadingCountries"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
        <app-input controlName="County"
          *ngIf="getSettlorFormGroup(i).get('Country')?.value.toLowerCase() === 'kenya'"
          [formGroup]="getSettlorFormGroup(i)"
          label={{countyLabel}} hint={{countyHint}}
          inputType="auto-complete"
          [ArrayItems]="CountyOptions"
          [loadingOptions]="loadingCounties"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
        <app-input
          *ngIf="region === 1 && getSettlorFormGroup(i).get('Country')?.value.toLowerCase() !== 'kenya'"
          [formGroup]="getSettlorFormGroup(i)" controlName="City"
          label="City | State" hint="Enter city or state of residence"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
      </div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="IDNo" label={{idLabel}} hint={{idHint}}
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="KraPin" label={{kraPinLabel}} hint={{kraPinHint}}
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
      </div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="Address" label={{addressLabel}} hint={{addressHint}}
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="Occupation" label={{occupationLabel}} hint={{occupationHint}} required="false"
          [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
      </div>
    </div>
  </ng-template>
  <!-- Panel 2: Upload Documents -->
  <ng-template #uploadDocsIndividual let-i="index">
    <div *ngIf="getSettlorFormGroup(i)">
      <div class="line-section"></div>

      <div class="row">
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="IDNoImage"
          [label]="idFileLabel"
          [fileFunction]="updateIDObject.bind(this, i)"
          [existingFileName]="settlors[i]?.IDNoImage?.name != '' ? settlors[i]?.IDNoImage?.name : '' "
          inputType="file"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
        <app-input [formGroup]="getSettlorFormGroup(i)" class="grid-item"
          controlName="KraPinImage"
          [label]="kraFileLabel"
          [fileFunction]="updateKraObject.bind(this, i)"
          [existingFileName]="settlors[i]?.KraPinImage?.name != '' ? settlors[i]?.KraPinImage?.name : '' "
          inputType="file"
          [validationMessages]="validationMessages" [formErrors]="formErrors">
        </app-input>
      </div>
    </div>
  </ng-template>

  <!-- ++++++++++++++++++++++ Settlor Type +++++++++++++++++++++++++ -->
  <div class="tab-form" *ngIf="!settlorFormVisible">
    <!-- Settlor Type selection -->
    <div class="formal">
      <h1 class="blue">{{title}}</h1>
      <p class="lead local">{{subtitle}}</p>
      <div class="row settlor" style="display: flex; align-items: center; justify-content: center;">
        <app-radios style="display: flex; width: 100%; align-items: center; justify-content: center;"
          labelOptionA={{organizationText}}
          labelOptionB={{individualText}}
          [selectedValue]="isSettlorOrganization"
          (valueChange)="onOptionChange($event)" >
        </app-radios>
      </div>

      <div class="badge-wrapper">
        <div class="badge">
          <p>{{sentence}}</p>
          <ul>
            <li>{{ settlorType === 0 ? point1Institution : point1Settlor }}</li>
            <li>{{point2}}</li>
            <li>{{point3}}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- BOTTOM OF FORM -->
    <app-form-bottom style="width: 100%;"
      [text]="loading ? loadingText : 'Next' "
      [formValid]="true"
      [showContinue]="'false'"
      [saveFunction]="updateProgress.bind(this)"
      [buttonClickHandler]="showSettlorForm.bind(this)">
    </app-form-bottom>
  </div>

  <!-- ++++++++++++++++++++++ Settlor Forms +++++++++++++++++++++++++ -->
  <!-- Institution Form -->
  <div class="form-80" *ngIf="settlorFormVisible && settlorType == 0">
    <h1 class="blue margin">{{formTitleAlt}}</h1>
    <p class="lead rocal">{{formSubtitleAlt}}</p>

    <!-- Insitution Settlor Journey -->
    <div formArrayName="settlors">
      <div *ngFor="let settlor of getSettlors().controls; let i=index" [formGroupName]="i" style="position: relative;">
        <!-- Accordion -->
        <app-section [panels]="institutionPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>
      </div>
    </div>
  </div>
  <app-form-bottom style="width: 100%;" *ngIf="settlorFormVisible && settlorType == 0"
    [text]="returnInstitutionNavigationText()"
    [formValid]="(settlors[settlors.length-1] && settlors[settlors.length-1].done) ? true :
      institutionForm.valid
    "
    [showContinue]="institutionForm.valid ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)"

    [buttonClickHandler]="
      settlorFormVisible ?
      (
          ( !addDesceased && settlors[settlors.length-1].docsDone && !settlors[settlors.length-1].done ) ?
          skipAddPrincipal.bind(this) :
          submitForm.bind(this)
      )
      : showSettlorForm.bind(this)
    ">
  </app-form-bottom>

  <!-- Individual Form -->
  <div class="form-80" *ngIf="settlorFormVisible && settlorType == 1">
    <h1 class="blue margin">{{formTitle}}</h1>
    <p class="lead rocal">{{formSubtitle}}</p>
    
    <div formArrayName="settlors">
      <div *ngFor="let settlor of getSettlors().controls; let i=index" [formGroupName]="i" style="position: relative;">
        <div style="height: 40px;" *ngIf="i > 1"></div>
        <p style="font-weight: 600; font-size: 1.3em;" class="blue margin" *ngIf="getSettlors().length > 1">
          {{'Settlor ' + (i+1)}}
        </p>

        <!-- Accordion -->
        <app-section [panels]="individualPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>

        <!-- REMOVE BUTTON -->
        <div class="action-buttons">
          <button mat-stroked-button type="button" class="remove" (click)="removeSettlor(i)" *ngIf="i > 0">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{
                  getSettlors().controls.length - 1 === i
                  ? removeButtonText
                  : removeSettlorText
                }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getSettlors() && settlors[i].done && !confirmFormMatchesRecord(i) "
            [disabled]="loading || loadingRemove" 
            (click)="updateRecord(i)" >
              <span class="button-text">
                {{ 'Update Settlor ' +(i+1) }}
              </span>
          </button>
        </div>
      </div>

      <!-- BUTTTON Add Settlor -->
      <div class="blueStroke row" [ngClass]="{'min-55' : getSettlors().length > 1}">
        <button mat-stroked-button *ngIf="settlors[settlors.length-1] && settlors[settlors.length-1].done === true"
          [disabled]="!individualForm.valid || loading || loadingRemove"
          class="general-stroked-button" type="button" (click)="addNewSettlor()">
          <span class="button-text">
            {{getSettlors().length === 1 || individualForm.valid && settlors[settlors.length-1].verified ? addSettlorText : addButtonText }}
          </span>
        </button>
      </div>
    </div>
  </div>
  <app-form-bottom style="width: 100%;"  *ngIf="settlorFormVisible && settlorType == 1"
    [text]="returnIndividualNavigationText()"
    [formValid]="
      !settlorFormVisible ? true :
      (settlors[settlors.length-1] && settlors[settlors.length-1].done) ? true :
      individualForm.valid ? true : false
    "
    [showContinue]="settlorFormVisible ? 'false' : individualForm.valid ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)"

    [buttonClickHandler]="
      settlorFormVisible ? submitForm.bind(this): showSettlorForm.bind(this)
    ">
  </app-form-bottom>
</form>
